import { AsyncPipe, DatePipe, JsonPipe, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacySnackBarModule, MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import {
  MatLegacyTableDataSource as MatTableDataSource,
  MatLegacyTableModule as MatTableModule,
} from '@angular/material/legacy-table';
import { DocumentsService } from '@cutting/main/shared/services/documents/documents.service';
import { CuttingDocumentForOrder, ICustomResponse, downloadFile } from 'cloud-shared-lib';
import * as printJS from 'print-js';
import { Observable, from } from 'rxjs';
import { concatMap, filter, finalize, tap } from 'rxjs/operators';

import { CdkTableModule } from '@angular/cdk/table';
import { OrderDetailService } from '../../order-detail.service';

@Component({
  selector: 'cutting-sys-documents',
  templateUrl: './sys-documents.component.html',
  styleUrls: ['./sys-documents.component.scss'],
  standalone: true,
  imports: [
    AsyncPipe,
    NgIf,
    DatePipe,
    JsonPipe,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
    MatProgressSpinnerModule,
    CdkTableModule,
    MatLegacySnackBarModule,
  ],
})
export class SysDocumentsComponent {
  @Input() publicApiKey = '';

  displayedColumns = ['name', 'type', 'size', 'date', 'download', 'print'];
  dataSource: MatTableDataSource<CuttingDocumentForOrder> = new MatTableDataSource();
  downloading: Set<number> = new Set();
  printing: Set<number> = new Set();

  sysDocuments$: Observable<ICustomResponse<CuttingDocumentForOrder[]>>;
  downloading$: Observable<ICustomResponse<Blob>>;

  constructor(
    private orderDetailService: OrderDetailService, //
    private snackBar: MatSnackBar,
    private documentsService: DocumentsService
  ) {
    this.sysDocuments$ = this.orderDetailService
      .getSystemDocuments()
      .pipe(tap(res => (this.dataSource.data = res.result)));
  }

  async downloadOrderDocument(item: CuttingDocumentForOrder): Promise<void> {
    this.downloading.add(item.id);

    this.downloading$ = from(
      this.documentsService.generateCuttingDoc(
        this.publicApiKey,
        item.script,
        this.orderDetailService.order.id,
        item.content
      )
    ).pipe(
      tap(genRes => {
        if (genRes.error) {
          this.snackBar.open($localize`Не удалось скачать файл`);
        }
      }),
      filter(genRes => !genRes.error),
      concatMap(genRes => this.orderDetailService.html2Pdf(genRes.res.outerHTML)),
      tap(response => {
        if (response.error) {
          this.snackBar.open($localize`Не удалось скачать файл`);
        } else if (response.result) {
          downloadFile(response.result, `${item.name}.pdf`);
        }
      }),
      finalize(() => this.downloading.delete(item.id))
    );
  }

  async printOrderDocument(item: CuttingDocumentForOrder): Promise<void> {
    this.printing.add(item.id);

    const genResult = await this.documentsService.generateCuttingDoc(
      this.publicApiKey,
      item.script,
      this.orderDetailService.order.id,
      item.content
    );

    if (genResult.error) {
      this.snackBar.open($localize`Не удалось скачать файл`);
    } else {
      const printOptions: any = {
        printable: genResult.res.outerHTML,
        type: 'raw-html',
      };

      printJS(printOptions);
    }

    this.printing.delete(item.id);
  }
}
